import * as React from 'react';
import { IFilterItem } from 'models/common';
import { IResultFilter } from 'models/search/resultfilter';
require('./style.css');

class SimpleFilter extends React.Component<IResultFilter, any> {
	constructor(props) {
		super(props);

		this.handleFilter = this.handleFilter.bind(this);
	}

	private handleFilter(e: any, val: any) {
		const btns = document.getElementsByClassName('filterItem');
		[].forEach.call(btns, (el) => {
			el.classList.remove('active');
		});
		e.target.classList.add('active');

		this.props.onFilter(val);
	}

	public render() {
		const { text, items, selectedValue } = this.props;

		const filterItems = items.map((item: IFilterItem, index: number) => {
			let itemClass = 'filterItem';
			if (selectedValue !== null && selectedValue === item.value) {
				itemClass = `filterItem active`;
			}

			return (
				<div key={`filterItem${index}`} className={itemClass} onClick={(e) => this.handleFilter(e, item.value)}>
					{item.text}
				</div>
			);
		});

		return (
			<div className="filterBox">
				{text ? <span>{text}</span> : null}
				{filterItems}
				<div className="clear" />
			</div>
		);
	}
}
export { SimpleFilter };
